<template>
  <section class="container content">
    <h1 class="mt-3">
      {{ $t('Anmelden') }}
    </h1>

    <b-form @submit.prevent="onSubmit">
      <b-form-group
        id="input-group-1"
        :label="$t('Benutzername') + ':'"
        label-for="input-username"
      >
        <b-form-input
          id="input-username"
          v-model="credentials.username"
          type="text"
          required
          :placeholder="$t('Benutzername')"
        />
      </b-form-group>

      <b-form-group
        id="input-group-2"
        :label="$t('Passwort') + ':'"
        label-for="input-password"
      >
        <div
          id="input-password"
          class="d-flex"
        >
          <div
            class="showPasswordButton"
            @click.prevent="toggleShow"
          >
            <Eye v-if="showPassword" />
            <EyeOff v-else />
          </div>

          <b-form-input
            v-if="showPassword"
            id="input-password-text"
            v-model="credentials.password"
            type="text"
            required
            :placeholder="$t('Passwort')"
          />
          <b-form-input
            v-else
            id="input-password-password"
            v-model="credentials.password"
            type="password"
            required
            :placeholder="$t('Passwort')"
          />
        </div>
      </b-form-group>

      <div
        v-if="error"
        class="invalid-feedback d-block my-4"
      >
        {{
          $t(
            'Der Nutzername und das Passwort stimmen nicht mit unseren Unterlagen überein.'
          )
        }}
        {{ $t('Bitte überprüfe deine Angaben und versuche es erneut.') }}
        <p class="mt-2">
          <a :href="localePath('/password/reset/')">
            {{ $t('Neues Passwort anfordern') }}
          </a>
        </p>
      </div>

      <b-button
        class="mt-3"
        :disabled="processing"
        type="submit"
        variant="primary"
      >
        <b-spinner
          v-if="processing"
          small
          class="mr-2"
        />
        {{ $t('Anmelden') }}
      </b-button>

      <div class="mt-4">
        <a :href="localePath('/password/reset/')">
          {{ $t('Passwort vergessen') }}?
        </a>
      </div>
    </b-form>
  </section>
</template>

<script>
import UserLoginGql from '../gql/UserLogin.gql'
import LearnPathUtils from '../mixins/LearnPathUtils'
import EyeOff from '../assets/images/eyeOff.svg'
import Eye from '../assets/images/eye.svg'
import Flow from '../mixins/Flow'
import { ampli } from '../mixins/Amplitude/index.js'

export default {
  components: {
    EyeOff,
    Eye,
  },
  mixins: [Flow, LearnPathUtils, ampli],
  data() {
    return {
      processing: false,
      error: false,
      credentials: {
        username: '',
        password: '',
      },
      showPassword: false,
    }
  },

  head() {
    return {
      title: this.$i18n.t('Anmelden | Lernpfad'),
    }
  },

  computed: {
    showDialog() {
      return typeof this.$route.query.showdialog !== 'undefined'
    },
    showDialogInvalid() {
      return typeof this.$route.query.showdialoginvalid !== 'undefined'
    },
    buttonLabel() {
      return this.showPassword ? 'Hide' : 'Show'
    },
  },

  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword
    },
    async onSubmit() {
      this.processing = true
      this.error = false

      try {
        this.credentials.username = this.credentials.username
          .trim()
          .toLowerCase()

        const res = await this.$apollo.mutate({
          mutation: UserLoginGql,
          variables: this.credentials,
        })

        await this.$apolloHelpers.onLogin(res.data.tokenAuth.token)

        ampli.identify(this.credentials.username, {
          email: this.$store.state.user.email
            ? this.$store.state.user.email
            : '',
          username: this.credentials.username,
          name: this.$store.state.user.name,
        })
        ampli.login({
          username: this.credentials.username,
        })
      } catch (e) {
        this.error = e
      }

      // TODO: identical with registrieren, refactor with a mixin, ev. Flow

      if (!this.error) {
        // update UI to user's language
        this.$i18n.locale = this.$store.state.user.language.toLowerCase()
        this.$i18n.setLocale(this.$i18n.locale)
        this.$i18n.setLocaleCookie(this.$i18n.locale)

        let pathRef
        if (this.$store.state.tmpLearnPath) {
          pathRef = await this.saveLearnPath(this.$store.state.tmpLearnPath)
        } else if (this.$store.state.copyLearnPath) {
          pathRef = await this.copyLearnPath(this.$store.state.copyLearnPath)
        }

        if (pathRef) {
          this.$router.push(this.localePath({ path: `/pfad/${pathRef}/admin` }))
        } else {
          this.$router.push(
            this.localePath({
              path: this.$route.query.next ? this.$route.query.next : '/',
            })
          )
        }
      }

      this.processing = false
    },
  },
}
</script>

<style
  scoped
  lang="scss"
>
.invalid-feedback {
  a {
    color: #dc3545;
  }
}

.showPasswordButton {
  margin: 0 1rem 0 0;
}
</style>
